const isAccountEnterprise = () => {
  if(window.currentUser) {
    return window.currentUser.is_enterprise_user && window.currentUser.is_enterprise_user == 1;
  }

  // called too soon
  console.error('isAccountEnterprise called before user was authenticated');
  return false;

};

export default isAccountEnterprise;
